// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Célula usuário na lista: avatar + nome + email (estilo da imagem) */
.styles_userCellWrapper__4cegS {
  align-items: center;
  display: flex;
  gap: 12px;
  padding: 8px 0;
}

/* Avatar com efeito de gradiente (mais claro topo-esquerda, mais escuro base) */
.styles_userCellAvatar__jTsKo {
  width: 36px !important;
  height: 36px !important;
  background: linear-gradient(145deg, #5ba3f7 0%, #1976d2 35%, #1565c0 100%) !important;
  color: #fff !important;
  font-size: 0.8125rem !important;
  font-weight: 700 !important;
  flex-shrink: 0;
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.2),
    0 1px 3px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.35);
}

.styles_userCellText__-gkgL {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.styles_userCellName__Z8Icd {
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  color: #212121;
  line-height: 1.2;
  letter-spacing: 0;
}

.styles_userCellEmail__ioxEx {
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 400;
  color: #757575;
  line-height: 1.2;
}

.styles_container_actions__UA\\+jx {
  align-items: center !important;
  display: flex !important;
  justify-content: space-between !important;
  margin-top: 1rem !important;
}

.styles_container_title__zTcq3 {
  font-family: Inter !important;
  font-size: 1.2rem !important;
  font-weight: 500 !important;
  max-width: 20rem !important;
  text-align: center !important;
}

.styles_margem_itens__RJt6w {
  margin-top: 1rem !important;
}

.styles_botao_redefinir__RK0fi {
  background-color: #18316e !important;
  cursor: pointer !important;
  color: #fff !important;
  text-align: center !important;
  border: none !important;
  font-family: "Inter" !important;
  font-size: 1rem !important;
  transition: transform 0.3s ease-in-out !important;
  border-radius: 4px !important;
  margin-top: 1rem !important;
  text-transform: capitalize !important;
  font-weight: 400 !important;
  width: 100% !important;
}

.styles_botao_redefinir__RK0fi:hover {
  /* transform: scale(1.05) !important; */
  background-color: #18306ed4 !important;
  color: #fff !important;
}

/* Wrapper da página com background cinza claro */
.styles_pageWrapper__VmC3c {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 24px 0;
}

/* Coluna documento com sigla CPF/CNPJ */
.styles_documentCell__ecjCC {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.styles_documentType__WUfG3 {
  font-size: 0.625rem;
  font-weight: 600;
  color: #9e9e9e;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.styles_documentNumber__E\\+Yix {
  font-size: 0.8125rem;
  color: #424242;
  font-weight: 400;
  line-height: 1.2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Usuarios/styles.module.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qFAAqF;EACrF,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,cAAc;EACd;;;2CAGyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,iDAAiD;EACjD,6BAA6B;EAC7B,2BAA2B;EAC3B,qCAAqC;EACrC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* Célula usuário na lista: avatar + nome + email (estilo da imagem) */\n.userCellWrapper {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n/* Avatar com efeito de gradiente (mais claro topo-esquerda, mais escuro base) */\n.userCellAvatar {\n  width: 36px !important;\n  height: 36px !important;\n  background: linear-gradient(145deg, #5ba3f7 0%, #1976d2 35%, #1565c0 100%) !important;\n  color: #fff !important;\n  font-size: 0.8125rem !important;\n  font-weight: 700 !important;\n  flex-shrink: 0;\n  box-shadow:\n    0 2px 8px rgba(0, 0, 0, 0.2),\n    0 1px 3px rgba(0, 0, 0, 0.12),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.35);\n}\n\n.userCellText {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.userCellName {\n  font-family: inherit;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #212121;\n  line-height: 1.2;\n  letter-spacing: 0;\n}\n\n.userCellEmail {\n  font-family: inherit;\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #757575;\n  line-height: 1.2;\n}\n\n.container_actions {\n  align-items: center !important;\n  display: flex !important;\n  justify-content: space-between !important;\n  margin-top: 1rem !important;\n}\n\n.container_title {\n  font-family: Inter !important;\n  font-size: 1.2rem !important;\n  font-weight: 500 !important;\n  max-width: 20rem !important;\n  text-align: center !important;\n}\n\n.margem_itens {\n  margin-top: 1rem !important;\n}\n\n.botao_redefinir {\n  background-color: #18316e !important;\n  cursor: pointer !important;\n  color: #fff !important;\n  text-align: center !important;\n  border: none !important;\n  font-family: \"Inter\" !important;\n  font-size: 1rem !important;\n  transition: transform 0.3s ease-in-out !important;\n  border-radius: 4px !important;\n  margin-top: 1rem !important;\n  text-transform: capitalize !important;\n  font-weight: 400 !important;\n  width: 100% !important;\n}\n\n.botao_redefinir:hover {\n  /* transform: scale(1.05) !important; */\n  background-color: #18306ed4 !important;\n  color: #fff !important;\n}\n\n/* Wrapper da página com background cinza claro */\n.pageWrapper {\n  background-color: #f5f5f5;\n  min-height: 100vh;\n  padding: 24px 0;\n}\n\n/* Coluna documento com sigla CPF/CNPJ */\n.documentCell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.documentType {\n  font-size: 0.625rem;\n  font-weight: 600;\n  color: #9e9e9e;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  line-height: 1.2;\n}\n\n.documentNumber {\n  font-size: 0.8125rem;\n  color: #424242;\n  font-weight: 400;\n  line-height: 1.2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userCellWrapper": `styles_userCellWrapper__4cegS`,
	"userCellAvatar": `styles_userCellAvatar__jTsKo`,
	"userCellText": `styles_userCellText__-gkgL`,
	"userCellName": `styles_userCellName__Z8Icd`,
	"userCellEmail": `styles_userCellEmail__ioxEx`,
	"container_actions": `styles_container_actions__UA+jx`,
	"container_title": `styles_container_title__zTcq3`,
	"margem_itens": `styles_margem_itens__RJt6w`,
	"botao_redefinir": `styles_botao_redefinir__RK0fi`,
	"pageWrapper": `styles_pageWrapper__VmC3c`,
	"documentCell": `styles_documentCell__ecjCC`,
	"documentType": `styles_documentType__WUfG3`,
	"documentNumber": `styles_documentNumber__E+Yix`
};
export default ___CSS_LOADER_EXPORT___;
